export const APP_SETTINGS = {
  adobeAnalyticsEnabled: true,
};

export const TIER_DESCRIPTIONS = {
  ENTRY: 'ENTRY',
  CORE: 'CORE',
  PRO: 'PRO',
  ULTIMATE: 'ULTIMATE',
};

export const MEMBERSHIP_STATUSES = {
  SUBSCRIBED: 'subscribed',
  PENDING: 'subscriptionpending',
  CANCELLED: 'cancelled',
  NONRENEW: 'nonrenew',
  EXPIRED: 'expired',
};

export const VALID_PROCESSOR_PLAN_IDS = [
  'XUWZ4283',
  'FS-17',
  'FS-06',
  'FS-04',
  'FS-02',
  'FS-05',
  'IUYW8734',
];

export const INSTRUMENT_TYPES = ['software', 'hardware'];
export const EXCLUDE_PRODUCTS = ['R-MIX', 'ZENOLOGY FX'];

export const sortOptions = ['Date Added', 'A-Z', 'Z-A', 'Price, Low To High', 'Price, High To Low'].map((opt) => ({
  key: opt,
  value: opt.toLowerCase(),
  text: opt,
}));

export const filterOptions = [
  'New',
  'Free',
  'Under $20',
  '$20 - $50',
  '$50 - $100',
  'Over $100',
];

export const excludeOffers = [
  '3-month membership',
  '3-months membership',
  'drum channel',
  'melodics for keys',
  'melodics for pads',
  'melodics for v-drums',
  'roland cloud academy',
  'jd-800 model expansion + 6mo ultimate',
];

export const softwareCategorizationOrder = [
  'Software Instruments',
  'GALAXIAS',
  'Software Effects',
  'Drum and Bass Machines',
  'ZENBEATS',
];

export const isActiveSale = false;
export const saleName = 'Holiday Sale';

// sale starts Nov 21th
export const blackFridayStartDate = new Date('2025-11-21');
// sale ends at the end of the day. Dec 9th
export const blackFridayEndDate = new Date('2025-12-10');

// NOTE: remove products or leave as empty array to not show offers with promotional information
/**
 * @typedef {Object} PromotionalOffer
 * @property {string} title
 * @property {number} price
 * @property {'Normal' | 'Black Friday'} promoType
 * @property {boolean} show
 * @property {string} discountPercentage
 * @property {number} nonPromoPrice
 * @property {string} [landingPageUrl]
 */

/** @type {PromotionalOffer[]} */
export const promotionalOffers = [
  {
    title: 'Drum Machine Collection',
    price: 199.00,
    promoType: 'Normal',
    show: true,
    discountPercentage: '60%',
    nonPromoPrice: 499.00,
    landingPageUrl: `${process.env.REACT_APP_LANDING_PAGE_BASE_PATH}/DrumMachineCollection`,
  },
  {
    title: 'TR-909',
    price: 49.00,
    promoType: 'Normal',
    show: true,
    discountPercentage: '67%',
    nonPromoPrice: 149.00,
    landingPageUrl: `${process.env.REACT_APP_LANDING_PAGE_BASE_PATH}/TR-909`,
  },
];

// lower priority promo offers
/** @type {PromotionalOffer[]} */
export const promoOffers = [];
